import { Link } from "react-router-dom";
import { Mail, MapPin, Globe } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { path: "/services", label: "Services" },
    { path: "/doing-business-bosnia", label: "Doing Business in BiH" },
    { path: "/industries", label: "Industries" },
    { path: "/blog", label: "Insights" },
    { path: "/about", label: "About" },
    { path: "/contact", label: "Contact" },
  ];

  const services = [
    { path: "/services/corporate", label: "Corporate Services" },
    { path: "/services/accounting", label: "Accounting Services" },
    { path: "/services/tax", label: "Tax Services" },
    { path: "/services/relocation", label: "Business Relocation" },
    { path: "/services/ma", label: "Mergers & Acquisitions" },
  ];

  return (
    <footer data-testid="footer" className="bg-[#0B2A4A] text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6" data-testid="footer-logo">
              <span className="text-2xl font-semibold font-['Sora']">
                VTZ<span className="text-[#2F6FED]">Backoffice</span>
              </span>
            </Link>
            <p className="text-slate-300 text-sm leading-relaxed mb-6">
              Corporate and operational infrastructure for international companies 
              entering Bosnia and Herzegovina.
            </p>
            <div className="flex items-center text-slate-300 text-sm">
              <MapPin className="w-4 h-4 mr-2 text-[#2F6FED]" />
              <span>Bosnia and Herzegovina</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-6 font-['Sora']">Company</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-slate-300 text-sm hover:text-[#2F6FED] transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-6 font-['Sora']">Services</h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service.path}>
                  <Link
                    to={service.path}
                    className="text-slate-300 text-sm hover:text-[#2F6FED] transition-colors duration-200"
                  >
                    {service.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-6 font-['Sora']">Contact</h4>
            <div className="space-y-4">
              <a
                href="mailto:contact@vtz-backoffice.com"
                data-testid="footer-email"
                className="flex items-center text-slate-300 text-sm hover:text-[#2F6FED] transition-colors duration-200"
              >
                <Mail className="w-4 h-4 mr-2 text-[#2F6FED]" />
                contact@vtz-backoffice.com
              </a>
              <a
                href="https://vtz-backoffice.com"
                data-testid="footer-website"
                className="flex items-center text-slate-300 text-sm hover:text-[#2F6FED] transition-colors duration-200"
              >
                <Globe className="w-4 h-4 mr-2 text-[#2F6FED]" />
                vtz-backoffice.com
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-slate-400 text-sm">
              © {currentYear} VTZ Backoffice. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <Link
                to="/contact"
                className="text-slate-400 text-sm hover:text-[#2F6FED] transition-colors"
              >
                Privacy Policy
              </Link>
              <Link
                to="/contact"
                className="text-slate-400 text-sm hover:text-[#2F6FED] transition-colors"
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
